// F138d: administration is a SURFACE, not a drawer hanging off the end of
// somebody else's page. It used to be rendered outside the view branching, so
// the same 13 tools sat under Dnes, under Klienti and under Detail - a footer
// on three pages that are not about administration. It is the fourth place an
// administrator can be, and only an administrator ever sees it.
export type StaffRouteView = "today" | "clients" | "detail" | "admin";

export interface StaffRoute {
  view: StaffRouteView;
  clientId: string | null;
  step: string | null;
  /** `?tool=` opens exactly one panel of Správa: the one the link is about. */
  tool: string | null;
}

export function staffRouteFromSearch(search: string): StaffRoute {
  const params = new URLSearchParams(search);
  const clientId = params.get("client");
  if (clientId) {
    return {
      view: "detail",
      clientId,
      step: params.get("staffStep"),
      tool: null
    };
  }
  const staff = params.get("staff");
  return {
    view: staff === "clients" ? "clients" : staff === "admin" ? "admin" : "today",
    clientId: null,
    step: null,
    tool: staff === "admin" ? params.get("tool") : null
  };
}

export function StaffNavigation(props: {
  active: StaffRouteView;
  t: (key: string) => string;
  onNavigate: (view: StaffRouteView) => void;
  detailDisabled?: boolean;
  /** The fourth place exists only for the role that may go there. A partner
   *  never sees a tab they would be refused at, which is the F44 law read the
   *  other way round: a control that cannot work is not drawn. */
  showAdmin?: boolean;
}) {
  const views: StaffRouteView[] = props.showAdmin
    ? ["today", "clients", "detail", "admin"]
    : ["today", "clients", "detail"];
  return (
    <nav className="partner-os-nav" aria-label={props.t("partnerOS.navigation.label")}>
      {views.map((view) => {
        // A closed control says WHY it is closed (wave 4 law). "Detail" used
        // to carry a bare `disabled`: no title, no aria-disabled, and a
        // disabled button swallows mouse events, so even a title would never
        // have surfaced. It reads as a broken menu item (audit P-18).
        // `aria-disabled` keeps the tab focusable and hoverable, so the
        // reason is reachable by both pointer and keyboard, and the click
        // leads to the ONE place where the missing client is picked.
        const locked = view === "detail" && Boolean(props.detailDisabled);
        const classes = [props.active === view ? "active" : "", locked ? "is-locked" : ""]
          .filter(Boolean).join(" ");
        return (
          <button
            aria-current={props.active === view ? "page" : undefined}
            aria-disabled={locked || undefined}
            className={classes || undefined}
            data-staff-route={view}
            key={view}
            onClick={() => props.onNavigate(locked ? "clients" : view)}
            title={locked ? props.t("partnerOS.navigation.detailLocked") : undefined}
            type="button"
          >
            {props.t(`partnerOS.navigation.${view}`)}
          </button>
        );
      })}
    </nav>
  );
}
